/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom'
import { MensajePagoIncorrecto } from './components/mensajePagoIncorrecto'
import { MensajePagoCorrecto } from './components/mensajePagoCorrecto'
import { MensajePagosLayout } from './MensajePagosLayout'

const MensajePagosPage = () => (
  <Routes>
    <Route element={<MensajePagosLayout />}>
      <Route path='pagado' element={<MensajePagoCorrecto />} />
      <Route path='cancelado' element={<MensajePagoIncorrecto />} />
    </Route>
  </Routes>
)

export { MensajePagosPage }
